/* eslint-disable react/jsx-no-target-blank */
import React from 'react';
import { css } from 'styled-components';
import { useStores } from 'src/utils/useStore';
import { checkValue, onImageLoadWithoutCache } from 'src/components/common/helper';
import gaLogger from 'src/utils/ga-logger';
import { Icon, IconProps } from 'src/components/common/ui/icon/icon';
import Layout from 'src/components/common/theme/Layout';
interface SocialLinksProps {
  socialModule?: any;
  exClass?: any;
}
const SocialLinks: React.FC<SocialLinksProps> = (props) => {
  const {
    cpcmslitefeed: { cpCmsLitePageData, spotlightPageData, conciergePageData }, sanityStore:{sanityPageData}
  } = useStores();

  const primaryColour = checkValue(cpCmsLitePageData)
    ? cpCmsLitePageData?.primaryColour
    : checkValue(spotlightPageData)
    ? spotlightPageData?.primaryColour
    : checkValue(conciergePageData)
    ? conciergePageData?.primaryColor
    : '';  
    const socialModuleIconColor = checkValue(cpCmsLitePageData)
    ? cpCmsLitePageData?.socialModuleIconColor
    : checkValue(spotlightPageData)
    ? spotlightPageData?.socialModuleIconColor
    : checkValue(conciergePageData)
    ? conciergePageData?.socialModuleIconColor
    : '';  

  let socialColor = '#000';    
  socialColor = socialModuleIconColor;
  const selectedSocialColor = checkValue(socialColor) ? socialColor : primaryColour;

  const { socialModule, exClass = '' } = props;
  let isShowSocialMod = false;
  if (checkValue(socialModule, true)) {
    isShowSocialMod = true;
  }

  const socailLinks = (e: any, url: string) => {
    gaLogger.logGa('link click', 'footer', url);
  };

  const socialImages = {
    // facebook: 'https://mesocp3.azureedge.net/media/h4inzrvp/facebook.svg',
    facebook: 'https://mesocp.azureedge.net/media/0u5bi422/facebookn.svg',
    // twitter: 'https://mesocp3.azureedge.net/media/8d800ae23ae1c99/twitter.svg',
    twitter: 'https://mesocp.azureedge.net/media/3z5phbsa/twittern.svg',
    // instagram: 'https://mesocp3.azureedge.net/media/8d800ae20f88c56/iinstagram.svg',
    instagram: 'https://mesocp.azureedge.net/media/qz4pzwal/iinstagramn.svg',
    // youtube: 'https://mesocp3.azureedge.net/media/8d800ae2527dd5f/youtube.svg',
    youtube: 'https://mesocp.azureedge.net/media/3fmcxgyu/youtuben.svg',
    flickr: 'https://mesocp.azureedge.net/media/8d800ae2060bbdc/flickr.svg',
    pinterest: 'https://mesocp.azureedge.net/media/8d800ae21da18d3/pinterest.svg',
    snapchat: 'https://mesocp.azureedge.net/media/8d800ae22f0cfb6/snapchat.svg',
    tiktok: 'https://mesocp.azureedge.net/media/rm0hmzzn/tiktok-share-icon.svg',
    vimeo: 'https://mesocp.azureedge.net/media/vb3fqozy/vimeo.svg',
    linkedin: 'https://mesocp.azureedge.net/media/kcabgoyn/linkedin-icon.svg'
  };

  const getSocialModules = () => {
    if (isShowSocialMod) {
      const template = socialModule.map((social, index) => {
        const logoProps: IconProps = {
          icon: {
            text: social.socialType.toLocaleLowerCase(),
            iconPath: onImageLoadWithoutCache(socialImages[social.socialType.toLocaleLowerCase()]),
            height: 20,
            width: 20,
            color: '',
          },

          background: {
            bgShape: 'square',
            bgColor: 'transparent',
            bgHeight: 30,
            bgWidth: 30,
          },
        };
        return (
          <a
            key={`socialLinks-${index}`}
            data-url={social.link}
            onClick={(e) => socailLinks(e, social.link)}
            href={social.link}
            target="_blank"
          >
            <Icon {...logoProps} />
          </a>
        );
      });

      return template;
    } else {      
      return '';
    }
  };

  const moduleCss = () => {
    return `                                     
              .footer-socail {
                a{
                  div{
                    .svg-icon{
                      // background-color:${primaryColour};
                      background-color:${selectedSocialColor};
                    }
                  }
                }              
              };                                                                                       
            `;
  };

  return (
    <Layout
      HtmlTag="section"
      className="social-content-section"
      css={css`
        ${moduleCss()}
      `}
    >
      <div className={`footer-socail ${exClass}`}>{getSocialModules()}</div>
    </Layout>
  );
};

export default SocialLinks; 
